import { useDescope } from '@descope/react-sdk';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useUserSessionState } from '@/common/user-session/state';
import { getUserSessionOptions } from '@/common/user-session/userSessionApi';

// See useUserSessionState for detailed notes
export const useUserSession = () => {
  const descope = useDescope();
  const sessionReady = useUserSessionState((state) => state.sessionReady);
  const sessionToken = sessionReady ? descope.getSessionToken() : null;
  const logout = useUserSessionState((state) => state.logout);

  // This should already be preloaded by the root loader
  const userSessionQuery = useQuery({
    ...getUserSessionOptions,
    enabled: !!sessionToken,
  });

  useEffect(() => {
    if (userSessionQuery.data) {
      Sentry.setUser({
        username: `${userSessionQuery.data.firstName} ${userSessionQuery.data.lastName}`,
        id: userSessionQuery.data.id,
        email: userSessionQuery.data.email,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [userSessionQuery.data]);

  return {
    sessionToken,
    user: sessionToken ? userSessionQuery.data : null,
    isFetching: !sessionToken || userSessionQuery.isFetching,
    error: userSessionQuery.error,
    refetch: userSessionQuery.refetch,
    logout,
  };
};
